"use client";
import { useTranslations } from "next-intl";
import React, { useState, useEffect, useRef } from "react";
import Image from "next/image";
import { Tabs } from "antd";

export default function SupportPage() {
	const t = useTranslations("support");
	const [activeTab, setActiveTab] = useState(t("warrantyTabTitle"));

	const userManualsRef = useRef<HTMLDivElement>(null);
	const servicePolicyRef = useRef<HTMLDivElement>(null);

	// Service Policy 内容数据
	const servicePolicyItems = [
		{
			id: 1,
			title: t("servicePolicyItem1Title"),
			icon: "/image/support/icon/1.png",
			content: t("servicePolicyItem1Content"),
		},
		{
			id: 2,
			title: t("servicePolicyItem2Title"),
			icon: "/image/support/icon/2.png",
			content: t("servicePolicyItem2Content"),
		},
		{
			id: 3,
			title: t("servicePolicyItem3Title"),
			icon: "/image/support/icon/3.png",
			content: t("servicePolicyItem3Content"),
		},
		{
			id: 4,
			title: t("servicePolicyItem4Title"),
			icon: "/image/support/icon/4.png",
			content: (
				<div>
					<p> {t("servicePolicyItem4Content")}</p>
					<p>{t("servicePolicyItem4-1")}</p>
					<div className="flex flex-col">
						<p>Facebook: STARY </p>
						<p>
							Instagram:
							<a href="https://www.instagram.com/stary_llc/">https://www.instagram.com/stary_llc/</a>
						</p>
						<p>
							Youtube: <a href="https://www.youtube.com/@STARYLLC">https://www.youtube.com/@STARYLLC</a>
						</p>
					</div>
				</div>
			),
		},
		{
			id: 5,
			title: t("servicePolicyItem5Title"),
			icon: "/image/support/icon/5.png",
			content: t("servicePolicyItem5Content"),
		},
	];

	// Tab内容数据
	const tabContents = {
		[t("warrantyTabTitle")]: {
			title: t("warrantyTabTitle"),
			content: (
				<div>
					<h4>{t("warrantySection1Title")}</h4>
					<p>{t("warrantySection1Content")}</p>

					<h4>{t("warrantySection2Title")}</h4>
					<p>{t("warrantySection2Content1")}</p>
					<p>{t("warrantySection2Content2")}</p>
					<p>{t("warrantySection2Content3")}</p>

					<h4>{t("warrantySection3Title")}</h4>
					<p>{t("warrantySection3Content")}</p>

					<h4>{t("warrantySection4Title")}</h4>
					<p>{t("warrantySection4Content")}</p>

					<h4>{t("warrantySection5Title")}</h4>
					<p>{t("warrantySection5Content1")}</p>
					<p>{t("warrantySection5Content2")}</p>
					<p>{t("warrantySection5Content3")}</p>
					<p>{t("warrantySection5Content4")}</p>
					<p>{t("warrantySection5Content5")}</p>
				</div>
			),
		},
		[t("logisticsTabTitle")]: {
			title: t("logisticsTabTitle"),
			content: (
				<div>
					<p>{t("logisticsContent1")}</p>
					<p>{t("logisticsContent2")}</p>
					<p>{t("logisticsContent3")}</p>
				</div>
			),
		},

		[t("paymentsTabTitle")]: {
			title: t("paymentsTabTitle"),
			content: (
				<div>
					<h4>{t("paymentsSection1Title")}</h4>
					<p>{t("paymentsSection1Content1")}</p>
					<p>{t("paymentsSection1Content2")}</p>

					<h4>{t("paymentsSection2Title")}</h4>
					<p>{t("paymentsSection2Content1")}</p>
					<p>{t("paymentsSection2Content2")}</p>
					<p>{t("paymentsSection2Content3")}</p>
					<p>{t("paymentsSection2Content4")}</p>
					<p>{t("paymentsSection2Content5")}</p>
				</div>
			),
		},
		[t("returnsTabTitle")]: {
			title: t("returnsTabTitle"),
			content: (
				<div>
					<p>{t("returnsTabIntro")}</p>

					<h4>{t("returnsSection1Title")}</h4>
					<p>{t("returnsSection1Content1")}</p>
					<p>{t("returnsSection1Content2")}</p>
					<p>{t("returnsSection1Content3")}</p>
					<p>{t("returnsSection1Content4")}</p>
					<p>{t("returnsSection1Content5")}</p>
					<p>{t("returnsSection1Content6")}</p>
					<p>{t("returnsSection1Content7")}</p>
					<p>{t("returnsSection1Content8")}</p>
					<p>{t("returnsSection1Content9")}</p>
					<p>{t("returnsSection1Content10")}</p>
					<p>{t("returnsSection1Content11")}</p>
					<p>{t("returnsSection1Content12")}</p>
					<p>{t("returnsSection1Content13")}</p>

					<h4>{t("returnsSection2Title")}</h4>
					<p>{t("returnsSection2Content1")}</p>
					<p>{t("returnsSection2Content2")}</p>
					<p>{t("returnsSection2Content3")}</p>
					<p>{t("returnsSection2Content4")}</p>
					<p>{t("returnsSection2Content5")}</p>
					<p>{t("returnsSection2Content6")}</p>
					<p>{t("returnsSection2Content7")}</p>
					<p>{t("returnsSection2Content8")}</p>
					<p>{t("returnsSection2Content9")}</p>

					<h4>{t("returnsSection3Title")}</h4>
					<p>{t("returnsSection3Content")}</p>

					<h4>{t("returnsSection4Title")}</h4>
					<p>{t("returnsSection4Content1")}</p>
					<p>{t("returnsSection4Content2")}</p>
					<p>{t("returnsSection4Content3")}</p>
					<p>{t("returnsSection4Content4")}</p>
					<p>{t("returnsSection4Content5")}</p>
					<p>{t("returnsSection4Content6")}</p>
					<p>{t("returnsSection4Content7")}</p>
					<p>{t("returnsSection4Content8")}</p>
				</div>
			),
		},
	};

	// 处理URL参数和hash
	useEffect(() => {
		// 处理完整URL，包括hash后面的查询参数
		const hash = window.location.hash;
		const hashParts = hash.split("?");
		const hashValue = hashParts[0].replace("#", "");

		// 滚动到对应的模块
		if (hashValue === "user-manuals" && userManualsRef.current) {
			userManualsRef.current.scrollIntoView({ behavior: "smooth" });

			// 如果hash包含查询参数，处理tab参数
			if (hashParts.length > 1) {
				const queryParams = new URLSearchParams(hashParts[1]);
				const tabParam = queryParams.get("tab");
				if (tabParam && tabContents[tabParam]) {
					setActiveTab(tabParam);
				}
			}
		} else if (hashValue === "service-policy" && servicePolicyRef.current) {
			servicePolicyRef.current.scrollIntoView({ behavior: "smooth" });
		}
	}, []);

	// 处理tab切换
	const handleTabChange = (tab) => {
		setActiveTab(tab);

		// 更新URL，但不导致页面刷新
		const newUrl = `/support#user-manuals?tab=${tab}`;
		window.history.pushState({}, "", newUrl);
	};

	return (
		<div className="bg-white pb-10 md:pb-20">
			{/* Banner 模块 11*/}
			<div className="relative h-[300px] w-full">
				<Image src="/image/sp.jpg" alt="Support Banner" fill style={{ objectFit: "cover" }} />
			</div>
			<div className=" flex items-center justify-center">
				<h1 className="pt-[50px] text-center text-4xl font-bold text-black">{t("pageTitle")}</h1>
			</div>
			{/* Service Policy 模块 */}
			<div
				id="service-policy"
				ref={servicePolicyRef}
				className="mx-auto mt-16 flex max-w-[1200px] flex-col items-center justify-center px-4"
			>
				<div className="w-full rounded-lg p-8">
					<h2 className="mb-6 text-center text-3xl font-bold">{t("servicePolicyTitle")}</h2>
					<div className="min-h-[200px] rounded-lg p-6">
						<div className="grid grid-cols-1 gap-6 md:grid-cols-2">
							{servicePolicyItems.map((item) => (
								<div
									key={item.id}
									className="flex items-center rounded-lg border border-red-500 bg-white p-4"
								>
									<div className="flex w-1/4 flex-col items-center">
										<div className="relative h-12 w-12">
											<Image src={item.icon} alt={item.title} fill />
										</div>
										<h3 className="mt-2 text-center text-red-500">{item.title}</h3>
									</div>
									<div className="w-3/4 pl-4 text-black">{item.content}</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>

			<div className="bg-[rgb(242,242,242)]">
				{/* User Manuals 模块 - 带Tab栏 */}
				<div
					id="user-manuals"
					ref={userManualsRef}
					className="mx-auto mt-16 flex max-w-[1200px] flex-col items-center justify-center px-4"
				>
					<div className="w-full rounded-lg bg-[rgb(242,242,242)] p-8">
						<h2 className="mb-6 text-center text-3xl font-bold">{t("userManualsTitle")}</h2>

						{/* Tab 导航 */}
						<div className="mb-6 flex w-full justify-center">
							<div className="flex rounded-lg bg-white p-1">
								{Object.keys(tabContents).map((tab) => (
									<button
										key={tab}
										onClick={() => handleTabChange(tab)}
										className={`px-6 py-3 text-lg font-medium transition-colors ${
											activeTab === tab
												? "rounded-lg bg-main text-white"
												: "rounded-lg text-gray-700 hover:bg-gray-100"
										}`}
									>
										{tab.charAt(0).toUpperCase() + tab.slice(1)}
									</button>
								))}
							</div>
						</div>

						{/* Tab 内容 */}
						<div className="min-h-[300px] rounded-lg bg-white p-6">
							<h3 className="mb-4 text-2xl font-semibold">{tabContents[activeTab].title}</h3>
							<p className="text-lg text-gray-700">{tabContents[activeTab].content}</p>
						</div>
					</div>
				</div>
			</div>

			{/* 联系表单 */}
			{/* <div className="mx-auto mt-16 max-w-[1200px] px-4">
				<ContactForm locale={locale} className="rounded-lg bg-[rgb(242,242,242)]" innerClassName="p-8" />
			</div> */}
		</div>
	);
}
